import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import Navbar from "./Navbar";
import FlightHome from "./FlightSearch";
import FeaturesSection from "./FeatureSection";
import FlightDestinations from "./FlightDestinations";
import AboutUsSection from "./AboutSection";
import FeaturedAirlines from "./FeaturedAirline";
import ClientReviews from "./ClientReviews";
import Footer from "./Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import About from "./About";
import Clients from "./Clients";
import Contact from "./Contact";
import PrivacyPolicy from "./PrivacyPolicy";
import RefundPolicy from "./RefundPolicy";
import TermsAndConditions from "./TermsAndCondition";
import StickyContactIcons from "./StickyContactIcon";
import CallUsBanner from "./CallUsBanner";
import ScrollToTop from "./ScrollToTop";
function App() {
  return (
    <div className="App d-flex flex-column min-vh-100">
      <ScrollToTop />
      <Navbar />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
        </Routes>
      </div>
      <StickyContactIcons />
      {/* <FlightHome />
      <FeaturesSection />
      <FlightDestinations />
      <AboutUsSection />
      <FeaturedAirlines />
      <ClientReviews /> */}
      <CallUsBanner />
      <Footer />
    </div>
  );
}

export default App;
